export default [
  {
    path: '/',
    name: 'Login',
    meta: { requiresAuth: false },
    component: () => import('@/components/functions/Auth/PgLogin')
  },
  {
    path: '/Home',
    name: 'Home',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/A0001Admin/A0001AdminIndex')
  },
  {
    path: '/Customers',
    name: 'Customers',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/C0002Customers/C0002CustomersIndex')
  },
  {
    path: '/Mailer',
    name: 'Mailer',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0501Mailer/M0501MailerIndex')
  },
  {
    path: '/Survey',
    name: 'Survey',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0601Survey/M0601SurveyIndex')
  },
  {
    path: '/Survey/:id/Submissions',
    name: 'SurveySubmission',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0611SurveySubmission/M0611SurveySubmissionIndex')
  },
  {
    path: '/SurveyForm/:id',
    name: 'SurveyForm',
    meta: { requiresAuth: false },
    component: () => import('@/components/functions/M0601SurveyForm/M0601SurveyFormIndex')
  },
  {
    path: '*',
    redirect: '/'
  }
]
